import { AccredibleChipComponentModule } from '@accredible-frontend-v2/components/chip';
import { AccredibleMultiSearchFilterModule } from '@accredible-frontend-v2/new-components/multi-search-filter';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { TranslocoModule } from '@jsverse/transloco';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AccredibleThemeableMultipleSearchInputComponent } from './multiple-search-input.component';

const MATERIAL_MODULES = [MatIconModule, MatButtonModule, MatInputModule];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AccredibleChipComponentModule,
    AccredibleMultiSearchFilterModule,
    InfiniteScrollModule,
    TranslocoModule,
    ...MATERIAL_MODULES,
  ],
  declarations: [AccredibleThemeableMultipleSearchInputComponent],
  exports: [AccredibleThemeableMultipleSearchInputComponent],
})
export class AccredibleThemeableMultipleSearchInputComponentModule {}
